export default __webpack_public_path__ + "static/media/brand-logo.3182f856.svg";